export { Modal } from './modal'
export type { ModalProps } from './modal'
